import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { twMerge } from '@belong/common';
import css from './box-marker.module.css.js';

function BoxMarker({
  onClick,
  children,
  containerClassName,
  className,
  before,
  after
}) {
  return jsxs(Fragment, {
    children: [before, jsx("div", {
      className: twMerge('absolute rounded-small bg-navy z-20 -translate-x-2/4 -top-2xl hover:bg-green hover:cursor-pointer hover:z-30', containerClassName),
      onClick: onClick,
      children: jsx("div", {
        className: twMerge('rounded-small px-xs shadow-marker', css.boxMarkerMap, className),
        children: children
      })
    }), after]
  });
}

export { BoxMarker };
